import { render, staticRenderFns } from "./EmailVerifyAlert.vue?vue&type=template&id=3afde30c&scoped=true&lang=pug"
import script from "./EmailVerifyAlert.vue?vue&type=script&lang=js"
export * from "./EmailVerifyAlert.vue?vue&type=script&lang=js"
import style0 from "./EmailVerifyAlert.vue?vue&type=style&index=0&id=3afde30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afde30c",
  null
  
)

export default component.exports